import React from "react";
import { get } from "lodash";
import circle_check from "../../../Assets/Images/circle_check.svg";
import "./SoothePassBanner.css";

const SoothePassBanner = ({ client, booking, onLearnMoreClick, onLoginClick }) => {
  const loggedIn = get(client, "loggedIn", false);
  const discountAvailable = get(client, "soothe_pass_discount_available", null);
  const discountLoading = get(client, "soothe_pass_discount_loading", false);

  // For non-logged-in users, check availability first
  if (!loggedIn) {
    // Still loading availability check
    if (discountLoading) {
      return null;
    }

    return (
      <div className="soothepass-anon-banner">
        <div className="anon-banner-content">
          <div className="anon-banner-text-section">
            <div className="anon-banner-header">
              UNLOCK SAVINGS WITH EVERY BOOKING:
            </div>
            <div className="anon-banner-main-text">
              SoothePass® members enjoy up to 25% off all services and add-ons.
            </div>
          </div>
          {discountAvailable ? <div className="anon-banner-offer-container">
             <div className="anon-banner-offer-badge">
              <span className="anon-banner-offer-badge-text">
                Limited Time Offer
              </span>
            </div>
            <div className="anon-banner-offer-text">
              Subscribe to SoothePass and unlock an additional 30% one-time savings!
            </div>
          </div> : null}
        </div>
        <div className="anon-banner-right">
          <button 
            className="anon-banner-cta" 
            onClick={() => {
              if (onLearnMoreClick) {
                onLearnMoreClick();
              } else {
                console.error('onLearnMoreClick function not provided');
              }
            }}
          >
            Learn more
          </button>
        </div>
      </div>
    );
  }
  // TODO double check responsiveness
  const isSoothePassSubscribed = get(client, "soothe_pass.soothe_pass_subscribed", false);
  const isSoothePassAvailable = get(
    client,
    "soothe_pass.soothe_pass_available",
    false
  );

  // Don't show banner if user is already subscribed or SoothePass is not available
  if (isSoothePassSubscribed || !isSoothePassAvailable) {
    return null;
  }

  const isAddedToCart = get(
    booking,
    "cart.info_fields.soothe_pass.subscription_applied_to_cart",
    false
  );
  const { discount } = get(client, "soothe_pass", {});
  const { has_discount, discount_type, marketing_text, service_text } = discount || {};
  const placeholder_text = "SoothePass™ members get up to 25% off all services and add-ons.";

  // Show success banner if prop is true
  if (isAddedToCart) {
    return (
      <div className="soothepass-success-banner">
        <div className="success-banner-content">
          <div className="success-banner-icon">
            <img className="check-icon-success-banner" src={circle_check} />
          </div>
          <div className="success-banner-text">
            SoothePass® added to cart. Select a service to continue.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="soothepass-member-banner">
      <div className="banner-content">
        <div className="banner-text-section">
          <div className="banner-header">
            UNLOCK SAVINGS WITH EVERY BOOKING:
          </div>
          <div className="banner-text">
            {marketing_text ? marketing_text : placeholder_text}
          </div>
        </div>
        {has_discount && (
          <div className="banner-offer-container">
            <div className="banner-offer-badge">
              <span className="banner-offer-badge-text">
                Limited Time Offer:
              </span>
            </div>
            <div className="banner-offer-text">{service_text}</div>
          </div>
        )}
      </div>
      <div className="banner-right">
        <button className="banner-cta" onClick={onLearnMoreClick}>Learn more</button>
      </div>
    </div>
  );
};

export default SoothePassBanner;
